import React, { useState, useEffect } from "react";
import { Form, Row, Col, Spinner } from "react-bootstrap";
import ImagePreview from "../../utilities/ImagePreview";
import { StepNavigation } from "../../utilities/StepperComponents";

const PersonalDetails = ({
	error,
	signatureURL,
	passportURL,
	data,
	refererName,
	handleChange,
	handleSubmit,
	submitError,
	disableButton,
	nextStep,
	prevStep
}) => {
	const [isOtherTitle, setIsOtherTitle] = useState(data?.title && !["Prof.", "Dr.", "Sir", "Rev.", "Chief", "Alhaji", "Mr.", "Mrs.", "Miss", "Lady"].includes(data.title));
	const [isSubmitting, setIsSubmitting] = useState(false);

	useEffect(() => {
		if (submitError?.message) {
			setIsSubmitting(false);
		}
	}, [submitError]);

	const handleTitleChange = (e) => {
		const value = e.target.value;
		setIsOtherTitle(value === "Others");
		handleChange(e);
	};

	const handleFormSubmit = (e) => {
		e.preventDefault();
		if (Object.keys(error).length === 0) {
			setIsSubmitting(true);
		}
		handleSubmit(e);
	};

	return (
		<div className="modern-form-container">
			<div className="alert alert-info mb-4" style={{ fontSize: '0.85rem' }}>
				<strong>Important:</strong> For the purpose of the LMCS Group Life Assurance, members are required to provide their correct 11‑digit National Identification Number (NIN), as the National Insurance Commission (NAICOM) has made it compulsory for any insurance policy to be valid.
			</div>
			<Form>
				{refererName && refererName.length > 0 && (
					<div className="modern-form-group">
						<label className="modern-label">Invited By</label>
						<input
							type="text"
							className="modern-form-control"
							defaultValue={refererName}
							readOnly
							style={{ backgroundColor: '#edf2f7', cursor: 'not-allowed' }}
						/>
					</div>
				)}

				<Row>
					<Col md={6}>
						<div className="modern-form-group">
							<label className="modern-label">Title</label>
							<select
								className="modern-form-control"
								name="title"
								defaultValue={data?.title}
								onChange={handleTitleChange}
							>
								<option value="">Select title</option>
								<option value="Prof.">Prof.</option>
								<option value="Dr.">Dr.</option>
								<option value="Sir">Sir</option>
								<option value="Rev.">Rev.</option>
								<option value="Chief">Chief</option>
								<option value="Alhaji">Alhaji</option>
								<option value="Mr.">Mr.</option>
								<option value="Mrs.">Mrs.</option>
								<option value="Miss">Miss</option>
								<option value="Lady">Lady</option>
								<option value="Others">Others</option>
							</select>
						</div>
					</Col>
					<Col md={6}>
						<div className="modern-form-group">
							<label className="modern-label">Gender</label>
							<select
								className="modern-form-control"
								name="gender"
								defaultValue={data?.gender}
								onChange={handleChange}
							>
								<option value="">Select gender</option>
								<option value="Male">Male</option>
								<option value="Female">Female</option>
								<option value="Others">Others</option>
							</select>
						</div>
					</Col>
				</Row>

				{isOtherTitle && (
					<div className="modern-form-group">
						<label className="modern-label">Specify Title</label>
						<input
							className="modern-form-control"
							type="text"
							name="title"
							placeholder="Enter your title"
							defaultValue={data?.title === "Others" ? "" : data?.title}
							onChange={handleChange}
						/>
					</div>
				)}

				<div className="modern-form-group">
					<label className="modern-label">Full Name</label>
					<input
						className={`modern-form-control ${error?.fullName ? 'is-invalid' : ''}`}
						type="text"
						name="fullName"
						placeholder="John Doe"
						defaultValue={data?.fullName}
						onChange={handleChange}
					/>
					{error?.fullName && <div className="invalid-feedback d-block">{error.fullName}</div>}
				</div>

				<Row>
					<Col md={6}>
						<div className="modern-form-group">
							<label className="modern-label">Date of Birth</label>
							<input
								className={`modern-form-control ${error?.birthDate ? 'is-invalid' : ''}`}
								type="date"
								name="birthDate"
								defaultValue={data?.birthDate}
								onChange={handleChange}
							/>
							{error?.birthDate && <div className="invalid-feedback d-block">{error.birthDate}</div>}
						</div>
					</Col>
					<Col md={6}>
						<div className="modern-form-group">
							<label className="modern-label">Email Address</label>
							<input
								className={`modern-form-control ${error?.email ? 'is-invalid' : ''}`}
								type="email"
								name="email"
								placeholder="john@example.com"
								defaultValue={data?.email}
								onChange={handleChange}
							/>
							{error?.email && <div className="invalid-feedback d-block">{error.email}</div>}
						</div>
					</Col>
				</Row>

				<Row>
					<Col md={4}>
						<div className="modern-form-group">
							<label className="modern-label">Phone Number</label>
							<input
								className={`modern-form-control ${error?.phone ? 'is-invalid' : ''}`}
								type="tel"
								name="phone"
								placeholder="08012345678"
								inputMode="numeric"
								pattern="0[0-9]{10}"
								maxLength="11"
								title="Enter one 11-digit phone number beginning with 0"
								defaultValue={data?.phone}
								onInput={(event) => {
									event.currentTarget.value = event.currentTarget.value.replace(/\D/g, "").slice(0, 11);
								}}
								onChange={handleChange}
							/>
							{error?.phone && <div className="invalid-feedback d-block">{error.phone}</div>}
						</div>
					</Col>
					<Col md={4}>
						<div className="modern-form-group">
							<label className="modern-label">NIN (11 Digits)</label>
							<input
								className={`modern-form-control ${error?.nin ? 'is-invalid' : ''}`}
								type="text"
								name="nin"
								placeholder="National ID Number"
								maxLength="11"
								defaultValue={data?.nin}
								onChange={handleChange}
							/>
							{error?.nin && <div className="invalid-feedback d-block">{error.nin}</div>}
						</div>
					</Col>
					<Col md={4}>
						<div className="modern-form-group">
							<label className="modern-label">Home Address</label>
							<input
								className={`modern-form-control ${error?.homeAddress ? 'is-invalid' : ''}`}
								type="text"
								name="homeAddress"
								defaultValue={data?.homeAddress}
								onChange={handleChange}
							/>
							{error?.homeAddress && <div className="invalid-feedback d-block">{error.homeAddress}</div>}
						</div>
					</Col>
				</Row>

				<Row className="mb-4">
					<Col md={6}>
						<div className="modern-form-group">
							<label className="modern-label">Passport Photograph</label>
							<div className="d-flex align-items-center gap-3">
								{passportURL && <ImagePreview url={passportURL} />}
								<input
									className={`modern-form-control ${error?.passport ? 'is-invalid' : ''}`}
									type="file"
									name="passport"
									onChange={handleChange}
								/>
							</div>
							{error?.passport && <div className="invalid-feedback d-block">{error.passport}</div>}
						</div>
					</Col>
					<Col md={6}>
						<div className="modern-form-group">
							<label className="modern-label">Digital Signature</label>
							<div className="d-flex align-items-center gap-3">
								{signatureURL && <ImagePreview url={signatureURL} />}
								<input
									className={`modern-form-control ${error?.signature ? 'is-invalid' : ''}`}
									type="file"
									name="signature"
									onChange={handleChange}
								/>
							</div>
							{error?.signature && <div className="invalid-feedback d-block">{error.signature}</div>}
						</div>
					</Col>
				</Row>

				<Row>
					<Col md={6}>
						<div className="modern-form-group">
							<label className="modern-label">Create Password</label>
							<input
								className={`modern-form-control ${error?.password ? 'is-invalid' : ''}`}
								type="password"
								name="password"
								placeholder="Minimum 6 characters"
								defaultValue={data?.password}
								onChange={handleChange}
							/>
							{error?.password && <div className="invalid-feedback d-block">{error.password}</div>}
						</div>
					</Col>
					<Col md={6}>
						<div className="modern-form-group">
							<label className="modern-label">Confirm Password</label>
							<input
								className={`modern-form-control ${error?.confirmPassword ? 'is-invalid' : ''}`}
								type="password"
								name="confirmPassword"
								defaultValue={data?.confirmPassword}
								onChange={handleChange}
							/>
							{error?.confirmPassword && <div className="invalid-feedback d-block">{error.confirmPassword}</div>}
						</div>
					</Col>
				</Row>

				<div className="modern-form-group mb-4">
					<div className="custom-control custom-checkbox d-flex gap-2">
						<input
							type="checkbox"
							name="terms"
							className="custom-control-input"
							id="termsCheck"
							onChange={handleChange}
							checked={data?.terms}
						/>
						<label className="custom-control-label" htmlFor="termsCheck" style={{ fontSize: '0.85rem', lineHeight: '1.4' }}>
							I agree and confirm that all the information provided are correct and true. Any false information can disqualify me from membership and the membership fee paid will not be refunded.
						</label>
					</div>
					{error?.terms && <div className="invalid-feedback d-block">{error.terms}</div>}
				</div>

				<StepNavigation
					currentStep={3}
					totalSteps={4}
					onPrev={prevStep}
					onNext={handleFormSubmit}
					disableNext={disableButton}
				/>
			</Form>
		</div>
	);
};

export default PersonalDetails;
